<template>
    <div>
        <car-headerbar :title="title" :isCustomLeft="isCustomLeft"/>
        <div v-if="!optionSetBtn" class="item-wrap">
            <div class="item no-condition">
                <me-cell center title="无条件跳题">
                    <template #right-icon>
                        <me-switch
                            v-model="topicData.skipJson.skipValue"
                            active-value="0"
                            inactive-value=""
                            active-color="#06B455"
                            inactive-color="#DBDBDB"
                            size="24"/>
                    </template>
                </me-cell>
                <div class="skip-wrap" v-if="topicData.skipJson.skipValue === '0'">
                    <div class="title">做完此题直接跳转到:</div>
                    <me-radio-group v-model="topicData.skipJson.skipTarget" is-cancel>
                        <me-cell-group>
                            <span
                                v-for="(topic, index) in topics"
                                :key="topic.topicCode">
                                <me-cell
                                    v-if="!topic.skip"
                                    :title="`${newTopicsList[index].index}.${topic.topicName}`"
                                    @click="handleClick(topic)"
                                    clickable>
                                    <template #right-icon>
                                        <me-radio
                                            :name="topic.topicCode"
                                            @click="topicData.skipJson.skipTarget = topicData.skipJson.skipTarget === topic.topicCode ? '' : topic.topicCode">
                                            <template #icon="props">
                                                <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                                            </template>
                                        </me-radio>
                                    </template>
                                </me-cell>
                            </span>
                            <span>
                                <me-cell
                                    :title="skipLast"
                                    clickable
                                    @click="topicData.skipJson.skipTarget = topicData.skipJson.skipTarget === 'end' ? '' : 'end'">
                                    <template #right-icon>
                                        <me-radio
                                            name="end"
                                            @click="topicData.skipJson.skipTarget = topicData.skipJson.skipTarget === 'end' ? '' : 'end'">
                                            <template #icon="props">
                                                <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                                            </template>
                                        </me-radio>
                                    </template>
                                </me-cell>
                            </span>
                        </me-cell-group>
                    </me-radio-group>
                </div>
            </div>
            <div class="item" v-if="/^(radio|rate|nps)$/.test(topicData.topicType)">
                <me-cell center title="按选项跳题">
                    <template #right-icon>
                        <me-switch
                            v-model="topicData.skipJson.skipValue"
                            active-color="#06B455"
                            inactive-color="#DBDBDB"
                            active-value="1"
                            inactive-value=""
                            size="24"/>
                    </template>
                </me-cell>
                <template v-if="topicData.skipJson.skipValue === '1'">
                    <div class="option" v-for="(option, index) in topicData.selectItem" :key="index">
                        <div class="option-title">{{option.itemKey}}</div>
                        <div class="skip-wrap">
                            <me-field
                                v-model="option.skipTargetName"
                                rows="1"
                                autosize
                                label=""
                                type="textarea"
                                readonly
                                @click="openOptionSet(option, index)"
                                placeholder="请选择需要跳转的题目">
                                <template #button>
                                    <me-icon name="arrow" />
                                </template>
                            </me-field>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <div class="skip-layer" v-else>
            <div class="option-skip-layer">
                <div class="tip"><me-icon class="close-icon" name="cross" @click="optionSetBtn=false"/>请选择跳转到：</div>
                <me-radio-group class="radio-group" v-model="skipTarget" is-cancel>
                    <me-cell-group>
                        <span
                            v-for="(topic, index) in topics"
                            :key="topic.topicCode">
                            <me-cell
                                v-if="!topic.skip"
                                :title="`${newTopicsList[index].index}.${topic.topicName}`"
                                clickable
                                @click="skipTarget = skipTarget === topic.topicCode ? '' : topic.topicCode">
                                <template #right-icon>
                                    <me-radio
                                        :name="topic.topicCode"
                                        @click="skipTarget = skipTarget === topic.topicCode ? '' : topic.topicCode">
                                        <template #icon="props">
                                            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                                        </template>
                                    </me-radio>
                                </template>
                            </me-cell>
                        </span>
                        <span>
                            <me-cell
                                :title="skipLast"
                                clickable
                                @click="skipTarget = skipTarget === 'end' ? '' : 'end'">
                                <template #right-icon>
                                    <me-radio
                                        name="end"
                                        @click="skipTarget = skipTarget === 'end' ? '' : 'end'">
                                        <template #icon="props">
                                            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                                        </template>
                                    </me-radio>
                                </template>
                            </me-cell>
                        </span>
                    </me-cell-group>
                </me-radio-group>
            </div>
        </div>
        <confirm @confirm="confirm"/>
    </div>
</template>
<script>
import { Questionnaire } from '@/network'
import { mixin } from '@/mixins'
import { addClass2, removeClass2 } from '@/util/status-util'
import browser from '@/util/browser'
import { Toast } from '@guazi-fe/melon'
import confirm from '../compontents/confirm.vue'
import activeIcon from '../images/checked-icon.png'
import inactiveIcon from '../images/unchecked-icon.png'

export default{
    name: 'skip',
    components: { confirm },
    data() {
        return {
            title: '跳题设置',
            topicData: {
                skipJson: {
                    skipTarget: '',
                },
            }, // 要设置的当前题目数据
            topics: {}, // 此问卷的数据
            skipTarget: '', // 跳题时的目标题ID；无条件在对象中，按选项在选项中
            optionSetBtn: false,
            currentOption: {},
            currentIndex: null,
            skipLast: '跳转问卷结尾，结束作答',
            activeIcon: activeIcon,
            inactiveIcon: inactiveIcon,
            newTopicsList: [],
            isCustomLeft: false,
        }
    },
    computed: {
        pageId() {
            return this.$route.params.pageId
        },
        topicId() {
            return this.$route.params.topicId
        },
    },
    created() {
        const { guaguaApp } = browser
        this.isCustomLeft = guaguaApp
        this.initData()
        this.getTopics()
    },
    mixins: [mixin],
    watch: {
        optionSetBtn(val) {
            document.documentElement.scrollTop = 0
            document.body.scrollTop = 0
        }
    },
    methods: {
        openOptionSet(option, index) {
            this.optionSetBtn = true
            this.currentIndex = index
            this.skipTarget = option.skipTarget ? option.skipTarget : ''
        },
        confirm() {
            let topic = null
            let index = null
            if (this.optionSetBtn) {
                // 按选项跳题
                if (this.skipTarget) {
                    topic = this.topics.find(item => item.topicCode === this.skipTarget)
                    index = this.topics.findIndex(item => item.topicCode === this.skipTarget)
                    this.topicData.selectItem[this.currentIndex].skipTargetName = topic ? `${this.newTopicsList[index].index}.${topic.topicName}`: '跳转问卷结尾，结束作答'
                    this.topicData.selectItem[this.currentIndex].skipTarget = this.skipTarget
                    this.optionSetBtn = false
                    return
                }
                this.topicData.selectItem[this.currentIndex].skipTargetName = ''
                this.topicData.selectItem[this.currentIndex].skipTarget = ''
                this.optionSetBtn = false
                return
            }
            
            this.save()
        },
        save() {
            let { skipJson, skipJson: { skipValue }, selectItem, topicType } = this.topicData
            let { batchIncrease } = this.$store.state.model
            let selectItems = []
            if (/^(rate|nps)$/.test(topicType)) {
                selectItems = selectItem
            } else {
                batchIncrease && batchIncrease.forEach((batchItem, index) => {
                    let item = selectItem[index] || {}
                    let newObj = {...item, itemKey: batchItem.value, itemIndex: batchItem.type === 0 ? '10000' : index, itemValue: index}
                    selectItems.push(newObj)
                })
            }
            
            if (skipValue === '0' || !skipValue) {
                // 无条件
                selectItems.forEach((item) => {
                    item.skipTo = ''
                    item.skipTarget = ''
                    item.skipTargetName = ''
                })
                skipValue = skipJson.skipTarget ? skipValue : ''
            }
            if (skipValue === '1' || !skipValue) {
                // 按选项跳题
                skipJson.skipTarget = ''
                skipValue = selectItems.some(item => item.skipTarget) ? skipValue : ''
            }
            let skipObj = {}
            skipObj.skipValue = skipValue
            if (typeof skipJson === 'object') {
                skipObj.skipTarget = skipJson.skipTarget

            }
            // 暂存
            this.$store.commit('updateSkipObj', {skipJson: skipObj, skipOption: skipValue, selectItems})
            this.$router.back({
                name: 'topic2',
                params: {
                    pageId: this.pageId,
                    topicId: this.topicId,
                },
            })
        },
        initData() {
            addClass2('body', 'loading')
            const data = {
                tid: this.tid,
                topicId: this.topicId,
            }
            Questionnaire.topicInfo(data).then((res) => {
                removeClass2('body', 'loading')
                const { data } = res.data
                this.topicData = {
                    ...data[0],
                    skipJson: {
                        ...this.topicData.skipJson,
                        ...data[0].skipJson,
                    }
                }
                // 缓存跳题逻辑数据
                let { skipObj, model, model: { topicType, score } } = this.$store.state
                if (topicType === 'rate') {
                    let selectLength = this.topicData.selectItem.length
                    if (score > selectLength) {
                        for (let i=0; i< score-selectLength; i++) {
                            this.topicData.selectItem.push({ itemKey: String(selectLength + 1 + i), itemIndex: String(selectLength + 1 + i), itemValue: String(selectLength + 1 + i) })
                        }
                    } else {
                        this.topicData.selectItem = skipObj && skipObj.selectItems ? skipObj.selectItems.slice(0, score) : this.topicData.selectItem.slice(0, score)
                    }
                }
                if (skipObj) {
                    let { skipOption, skipJson, selectItems } = skipObj
                    this.topicData.skipOption = skipOption
                    this.topicData.skipJson = skipJson
                    topicType === 'rate' ? null : this.topicData.selectItem = selectItems
                } else if (model.batchIncrease && model.batchIncrease.length) {
                    let batchItem = []
                    let selectItem = this.topicData.selectItem
                    let itemObj = {}
                    model.batchIncrease.forEach((item, index) => {
                        itemObj = selectItem[index] || {}
                        batchItem.push({...itemObj, itemKey: item.value, itemIndex: item.type === 0 ? '10000' : String(index), itemValue: String(index)})
                    })
                    this.topicData.selectItem = batchItem
                }
            }).catch((error) => {
                removeClass2('body', 'loading')
                console.log(error.response)
                Toast.fail(error.response.data.message)
            })
        },
        getTopics() {
            const data = {
                tid: this.tid,
                pageId: this.pageId,
            }
            addClass2('body', 'loading')
            Questionnaire.getQuestionDetail(data).then((res) => {
                removeClass2('body', 'loading')
                const { data: { topicsList } } = res.data
                const i = topicsList.findIndex(item => item.topicCode === this.topicId)
                topicsList.forEach((ele, index) => {
                    index <= i || ele.topicType === 'paragraph' ? ele.skip = true : null
                })
                this.topics = topicsList
                this.dealTopics()
            }).catch((error) => {
                removeClass2('body', 'loading')
                console.log(error.response)
                Toast.fail(error.response.data.message)
            })
        },
        dealTopics() {
            let time = 0
            this.newTopicsList = this.topics.map((item, index) => {
                let newIndex = 0
                if (item.topicType == 'paragraph') {
                    time += 1
                }
                newIndex = index - time
                return { index: newIndex + 1 }
            })
        },
        handleClick(topic) {
            this.topicData.skipJson.skipTarget = this.topicData.skipJson.skipTarget === topic.topicCode ? '' : topic.topicCode
        },
    }
}
</script>
<style scoped lang="scss">
    .item-wrap{
        padding-top: .4rem;
        border-bottom: 1.75rem solid #f7f7f7;
    }
    .item{
        margin: 0 .4rem .4rem .4rem;
        background: #FBFBFC;
        &:last-child{
            margin-top: .4rem;
        }
        .me-cell{
            border-radius: 6PX;
            &::after{
                display: none;
            }
        }
        &.no-condition .skip-wrap{
            padding-right: 0;
            .me-hairline--top-bottom::after, .me-hairline-unset--top-bottom::after{
                border-width: 0;
            }
            .me-cell{
                padding: 0.43rem .43rem .43rem 0;
                background: #FBFBFC;
                border-bottom: 1px solid #F2F4F6;
                padding-left: 0;
                color: #222;
                line-height: .54rem;
                font-size: .38rem;
            }
        }
        .skip-wrap{
            padding: 0 .43rem;
            .title{
                margin-top: 0.43rem;
                font-size: .32rem;
            }
        }
        .option {
            &:last-child{
                padding-bottom: .4rem;
            }
            .me-cell{
                border: 1px solid #DBDBDB;
            }
        }
        .option-title{
            margin: .64rem .43rem .32rem;
            color: #9298A8;
            line-height: .54rem;
            font-size: .38rem;
            &::before{
                display: inline-block;
                content: '';
                margin-right: 0.16rem;
                width: .16rem;
                height: .16rem;
                border-radius: 50%;
                background: #9298A8;
                vertical-align: .05rem;
            }
        }
    }
    .skip-layer{
        min-height: 100vh;
        .tip{
            padding-left: .43rem;
            color: #9298A8;
            font-size: .43rem;
            line-height: 1.6rem;
            border-bottom: 1px solid #DBDBDB;
            position: fixed;
            left: 0;
            z-index: 1;
            width: 100%;
            background: #fff;
            .close-icon{
                font-size: .54rem;
                vertical-align: -.11rem;
                margin-right: .22rem;
            }
        }
        .radio-group{
            padding: 1.6rem .32rem 0 .59rem;
            border-bottom: 1.75rem solid #f7f7f7;
            background: #fff;
        }
        .me-hairline--top-bottom::after, .me-hairline-unset--top-bottom::after{
            border-width: 0;
        }
        .me-cell{
            padding: .43rem .43rem .43rem .11rem;
            border-bottom: 1px solid #F2F4F6;
            margin-right: .59rem;
            color: #222;
            font-size: .38rem;
            line-height: .54rem;
        }
    }
    .img-icon{
        width: .48rem;
    }
    ::v-deep .me-cell__title>span{
        word-break: break-all;
    }
</style>
